import { Protocol, Bilingual, PhaseKind } from '../data/protocols';

export function patternString(protocol: Protocol): Bilingual {
  const no = protocol.phases.map((p) => `${p.seconds}s ${p.label.no}`).join(' · ');
  const en = protocol.phases.map((p) => `${p.seconds}s ${p.label.en}`).join(' · ');
  return { no, en };
}

// Whole-second marks in (prevElapsed, curElapsed] that are >= 1 and < phaseSeconds.
// Used to fire a counting tick once per second, never on 0 or the closing boundary.
export function ticksToFire(prevElapsed: number, curElapsed: number, phaseSeconds: number): number[] {
  const out: number[] = [];
  for (let s = Math.floor(prevElapsed) + 1; s <= Math.floor(curElapsed); s++) {
    if (s >= 1 && s < phaseSeconds) out.push(s);
  }
  return out;
}

export function planString(protocol: Protocol): Bilingual {
  const pattern = patternString(protocol);
  if (protocol.cycles) {
    return {
      no: `${protocol.cycles} sykluser · ${pattern.no}`,
      en: `${protocol.cycles} cycles · ${pattern.en}`,
    };
  }
  if (protocol.durationSec) {
    const min = Math.round(protocol.durationSec / 60);
    return { no: `${min} min · ${pattern.no}`, en: `${min} min · ${pattern.en}` };
  }
  return pattern;
}

export function nextPhaseKind(protocol: Protocol, index: number): PhaseKind {
  const phases = protocol.phases;
  return phases[(index + 1) % phases.length].kind;
}
